import type { EntityAction } from "@firecms/core";
import { SettingsIcon } from "@firecms/ui";
import type { Space } from "../collections/spaces";
import { CONTENT_EDITOR_LABEL } from "../workspace/workspaceLabels";
import { tableOnlyEntityAction } from "./entityActionDefaults";
import { openSpaceFromEntity } from "./workspaceNavigationBridge";

export function buildContentEditorEntityAction(
  accountId: string
): EntityAction<Space> {
  return {
    key: "content-editor",
    name: CONTENT_EDITOR_LABEL,
    icon: <SettingsIcon />,
    ...tableOnlyEntityAction,
    collapsed: false,
    onClick: ({ entity }) => {
      if (!entity) {
        return;
      }
      openSpaceFromEntity(entity, accountId);
    },
  };
}
